import { render, staticRenderFns } from "./LessonBuilder.vue?vue&type=template&id=181c78a0&scoped=true&"
import script from "./LessonBuilder.vue?vue&type=script&lang=js&"
export * from "./LessonBuilder.vue?vue&type=script&lang=js&"
import style0 from "./LessonBuilder.vue?vue&type=style&index=0&id=181c78a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c78a0",
  null
  
)

component.options.__file = "LessonBuilder.vue"
export default component.exports